import { useAuthOptional } from '../contexts/authContextValue';
import { istModeration } from '../utils/moderation';

/**
 * Ob die angemeldete Person moderieren darf (ADMIN/MODERATOR) — Begründung in `utils/moderation.ts`.
 *
 * Ohne `AuthProvider` (die Formular-Tests rendern ohne) gilt „darf nicht": die Oberfläche bietet dann
 * weniger an, nie mehr, als der Server zulässt.
 *
 * ⚠️ Seiten-Tests, die `authContextValue` per `vi.mock` ersetzen, müssen `useAuthOptional` mitliefern
 * (`ContentManagement.test.tsx`) — sonst bricht der Test am fehlenden Export ab.
 */
export const useDarfModerieren = (): boolean => istModeration(useAuthOptional()?.user?.role);
